import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Link} from 'shells/link/link';

import {BulkEmailStatusText} from './bulk-email-status-text';

import styles from './bulk-email-warnings.module.css';

type Props = {
    missingFieldsCount: number;
    missingFieldsHref: string;
    missingEmailsCount: number;
    missingEmailsHref: string;
    hasReceivedTemplateRecentlyCount: number;
};

export function BulkEmailWarnings(props: Props) {
    const {
        missingFieldsCount,
        missingFieldsHref,
        missingEmailsCount,
        missingEmailsHref,
        hasReceivedTemplateRecentlyCount,
    } = props;

    const bullets = [];

    if (missingFieldsCount) {
        bullets.push(
            <div className={styles['warning-line']}>
                {missingFieldsCount} are missing template requirements.
                <Link newTab={true} href={missingFieldsHref} variant='primary'>
                    View list
                </Link>
            </div>
        );
    }
    if (hasReceivedTemplateRecentlyCount) {
        bullets.push(
            <div className={styles['warning-line']}>
                {hasReceivedTemplateRecentlyCount} recently received this template.
            </div>
        );
    }
    if (missingEmailsCount) {
        bullets.push(
            <div className={styles['warning-line']}>
                {missingEmailsCount} are missing an email address and won’t receive this email.
                <Link newTab={true} href={missingEmailsHref} variant='primary'>
                    View list
                </Link>
            </div>
        );
    }

    return (
        <React.Fragment>
            <BulkEmailStatusText
                variant='warning'
                text='There are issues with some of the recipients of this template:'
            />
            <div className={styles['issue-list']}>
                <BulletedList bullets={bullets} />
            </div>
        </React.Fragment>
    );
}
